import { VueClass } from 'vue-class-component/lib/declarations';
import Vue from "vue";
import { distinct } from '../helpers';

/**
 * Author: Arnaud PEZEL
 * Call method from super component or mixin
 * Example :
 * ```
 * mtd() {
 *  this.$super().mtd();
 * }
 * ```
 */
export const VueSuper = {
  install(Vue) {
    Vue.prototype.$super = function () {
      return new Proxy(this, {
          get: (obj, prop) => {
            const ctor  = (obj.constructor as any);
            const hierarchy = traverseSuperComponents(ctor);
            const superMtdTgt = hierarchy.find(
              clazz => prop in ((clazz as any).options.methods ?? {})
                && clazz.options.methods[prop] != ctor.options?.methods?.[prop]
            );
            if (superMtdTgt) {
              return (superMtdTgt as any).options.methods[prop].bind(this);
            }
            const superComputedTgt = hierarchy.find(
              clazz => prop in ((clazz as any).options.computed ?? {})
                && clazz.options.computed[prop] != ctor.options?.computed?.[prop]
            );
            if (superComputedTgt) {
              return (superComputedTgt as any).options.computed[prop].get.call(this);
            }
          }
      })
    };
  }
};

/**
 * Author: Arnaud PEZEL
 * Type utility method to instruct type checking that the class is a mixin
 * over the provided types
 * exemple:
 * ```
 * class A extends MixinOver<B>() {
 *  ...
 * }
 * ```
 * @param Ctors
 */
export function MixinOver<T>(Ctor: VueClass<any> = Vue): VueClass<T> {
  return Ctor;
};



/* PRIVATE API */

const traverseSuperComponents = (ctor: any, tree: any[] = []) => {
  if (!ctor) return [];
  const mixins = distinct(
    [
      ctor.super,
      ...Object.values(ctor.options?.components ?? {}),
      ...(ctor.options?.mixins ?? [])
    ]
    .filter(c => c?.options && !tree.some(tc => tc === c || (tc.cid && tc.cid === c.cid)))
  );

  return distinct(
    [
      ...mixins,
      ...mixins.flatMap(m => traverseSuperComponents(m, [ctor, ...tree, ...mixins]))
    ].filter(Boolean)
  );
};
